<template>
</template>

<script>
export default {
  mounted() {
    this.success();
  },
  methods: {
    success() {
      // window.cbPostMessage({key: "cb.success", value: this.$store.state.auth.hpToken});
    }
  }
}
</script>



// WEBPACK FOOTER //
// ThankyouComponent.vue?a3006118